import { useTranslation } from "react-i18next";

export function LanguageProvider({ children }) {
  return children;
}

export function useLanguage() {
  const { t, i18n } = useTranslation();

  return {
    t,
    language: i18n.resolvedLanguage || i18n.language,
    setLanguage: (language) => i18n.changeLanguage(language)
  };
}
